import React from "react";
import { Img } from "../Img";
import { Heading } from "../Heading";

interface UserProfileProps {
    userAvatar: string;
    userName: string;
    userPosition: string;
    feedbackDate: string;
    requestDescription: string;
    button: string;
    button_collapse: string;
    feedbackNumber: string;
    className?: string;
    isExpanded: boolean;
    onToggle: () => void;
}

const UserProfile: React.FC<UserProfileProps> = ({
                                                     userAvatar,
                                                     userName,
                                                     userPosition,
                                                     feedbackDate,
                                                     requestDescription,
                                                     button,
                                                     button_collapse,
                                                     feedbackNumber,
                                                     className,
                                                     isExpanded,
                                                     onToggle,
                                                 }) => {
    const clampStyle: React.CSSProperties = !isExpanded
        ? {
            display: "-webkit-box",
            WebkitLineClamp: 4,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
        }
        : {};

    return (
        <div
            className={`bg-[#F6F6F6] rounded-[32px] p-10 sm:p-6 md:p-6 min-h-[348px]
             flex flex-col
             ${
                className ?? ""
            }`}
        >
            <div className="flex items-center mb-5">
                <Img
                    src={userAvatar}
                    alt={userName}
                    className="w-12 h-12 rounded-full mr-4 object-cover"
                />
                <div>
                    <div className="text-[#191c2f] font-semibold">{userName}</div>
                    <div className="text-gray-500 text-sm">{userPosition}</div>
                </div>
                <div className="ml-auto text-sm text-gray-400 mb-7 sm:mb-10">{feedbackDate}</div>
            </div>

            <div className="transition-all duration-300 ease-in-out overflow-hidden">
                <p
                    className="text-[#191c2f] leading-[28px] font-medium text-[19px] whitespace-pre-line"
                    style={clampStyle}
                >
                    {requestDescription}
                </p>
            </div>

            {/* Кнопка "Подробнее" */}
            <div className="mt-auto flex justify-between items-center">
                <button onClick={onToggle} className=" flex items-center gap-1">
                    <Heading className="font-medium size-[17px] leading-6 text-[#1B1F3BA6] whitespace-nowrap">
                        {isExpanded ? button_collapse : button}
                    </Heading>
                    <Img
                        src={
                            isExpanded
                                ? "/images/arrow_close.svg"
                                : "/images/arrow_open.svg"
                        }
                        className={isExpanded ? "ml-[36px] mt-2" : "ml-16 mt-2"}
                    />
                </button>
                <div className="text-[#FFFFFF] text-sm bg-[#B0B0B0] rounded-full px-2 py-1">{feedbackNumber}</div>
            </div>
        </div>
    );
};

export default UserProfile;
